
export default {
  name: 'Recaptcha',
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      widgetId: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$renderRecaptcha(this.id);
    });
  },
  beforeDestroy() {
    if (this.widgetId && window.grecaptcha) {
      window.grecaptcha.reset(this.widgetId);
    }
  }
}
